import { render, staticRenderFns } from "./StoreInsights.vue?vue&type=template&id=3363ea78&"
import script from "./StoreInsights.vue?vue&type=script&lang=js&"
export * from "./StoreInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3363ea78')) {
      api.createRecord('3363ea78', component.options)
    } else {
      api.reload('3363ea78', component.options)
    }
    module.hot.accept("./StoreInsights.vue?vue&type=template&id=3363ea78&", function () {
      api.rerender('3363ea78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/StoreInsights.vue"
export default component.exports